module.exports = __webpack_public_path__ + "static/media/ko.1236660e.png";